'use client';
import { motion } from 'framer-motion';
import { useTranslations } from 'next-intl';
import { fadeInUp, viewportOnce } from '@/lib/animations';

export default function IntegrationProcess() {
  const t = useTranslations('Banks.Integration');

  const steps = [
    {
      stepNumber: '01',
      titleKey: 'step_1_title',
      descKey: 'step_1_desc',
      isFinal: false,
    },
    {
      stepNumber: '02',
      titleKey: 'step_2_title',
      descKey: 'step_2_desc',
      isFinal: false,
    },
    {
      stepNumber: '03',
      titleKey: 'step_3_title',
      descKey: 'step_3_desc',
      isFinal: false,
    },
    {
      stepNumber: '04',
      titleKey: 'step_4_title',
      descKey: 'step_4_desc',
      isFinal: true,
    },
  ];

  return (
    <motion.section
      aria-labelledby="integration-process-heading"
      className="w-full bg-white py-16 sm:py-24 px-6 sm:px-10 lg:px-16"
      initial="hidden"
      whileInView="visible"
      viewport={viewportOnce}
      variants={fadeInUp}
    >
      <div className="max-w-8xl mx-auto space-y-10">
        <div className="space-y-3">
          <span className="text-[10px] sm:text-xs font-bold tracking-widest color-primary uppercase block">
            {t('badge')}
          </span>
          <h2 id="integration-process-heading" className="text-3xl sm:text-4xl font-extrabold text-gray-900 tracking-tight">
            {t('heading')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 relative">
          {steps.map((step, idx) => (
            <div key={idx} className="flex gap-1">
              <div className="bg-white border border-gray-100 rounded-3xl p-6 sm:p-8 shadow-sm hover:shadow-md transition-shadow duration-200 flex flex-col justify-between relative group">
                <div className="space-y-5">
                  {step.isFinal ? (
                    <div className="w-10 h-10 rounded-full bg-emerald-50 text-emerald-500 border border-emerald-100 flex items-center justify-center shrink-0">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                  ) : (
                    <div className="w-10 h-10 rounded-full bg-blue-600 text-white font-bold text-xs flex items-center justify-center shrink-0">
                      {step.stepNumber}
                    </div>
                  )}
                  <div className="space-y-2">
                    <h3 className="text-base sm:text-lg font-extrabold text-gray-900 tracking-tight">
                      {t(step.titleKey)}
                    </h3>
                    <p className="text-xs sm:text-sm text-gray-500 leading-relaxed font-normal">
                      {t(step.descKey)}
                    </p>
                  </div>
                </div>
              </div>
              {!step.isFinal && (
                <div className="hidden lg:flex items-center justify-center z-10 text-gray-300 pointer-events-none px-auto min-w-[60px]">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </div>
              )}
            </div>
          ))}
        </div>

      </div>
    </motion.section>
  );
}